import React, { useEffect } from 'react';
import useLogOut from 'hooks/useLogOut';

const Logout = () => {
  const { logout } = useLogOut();

  useEffect(() => {
    logout();
  }, [logout]);

  return <div>Logging out...</div>;
};

export default Logout;